export default "__VITE_ASSET__Dii9Z0eR__"